export default __webpack_public_path__ + "alberta-sync.f695e84ff3cf43da9dbe.svg";